import axios from 'axios';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { firebaseApp } from 'firebaseConfig';
import { filenameToContentType } from 'components/ReferenceImageGenerator/helpers';

export const getDownloadUrlFromGS = async (gs: string): Promise<string> => {
  const downloadURL = await getDownloadURL(ref(getStorage(firebaseApp), gs));

  return downloadURL;
};

export const getFirebaseFile = async (url: string, fileType?: string): Promise<File> => {
  const newImage = await axios.get(url, { responseType: 'blob' });
  // prefer the type the server sent; the URL extension misses webp/heic/gif and yields octet-stream
  const blobType: string = newImage.data?.type ?? '';
  const contentType =
    !fileType && blobType.startsWith('image/') ? blobType : filenameToContentType(fileType || url.split('?')[0], 'png');
  const imageFile = new File([newImage.data], 'temp', { type: contentType });

  return imageFile;
};
